import { PRODUCT_PRICE_MAX } from '@fourthwall/utils/dist/constants'
import React from 'react'
import { CurrencyInput } from '../../../../inputs/CurrencyInput'
import * as S from './styled'
import type { Props } from './types'

export const SellingPriceInput = ({ value, onValueChange, onBlur }: Props) => {
  return (
    <S.Container>
      <S.Label>Your selling price</S.Label>
      <S.InputContainer>
        <CurrencyInput
          size="small"
          fullWidth
          min={0}
          max={PRODUCT_PRICE_MAX}
          value={value}
          onValueChange={onValueChange}
          onBlur={onBlur}
        />
      </S.InputContainer>
    </S.Container>
  )
}
